import styles from "./indicator.module.scss";
export const Dot = ({
  totalLength,
  activeIndex,
  onClick,
}: {
  totalLength: number;
  activeIndex: number;
  onClick?: (index: number) => void;
}) => {
  return (
    <div className={`${styles["indicator"]} ${styles["indicator-dot"]}`}>
      {totalLength > 0 && (
        <ul>
          {Array.from({ length: totalLength }).map((_, index) => (
            <li
              key={`dot-${totalLength}-${index}`}
              className={`${styles["dot"]} ${styles[`${activeIndex === index ? "dot-active" : ""}`]}`}
            >
              <button onClick={() => onClick && onClick(index)} type="button">
                {index + 1}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
